import { Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { LabelKeyToProofType, ProofTypeLabelKeys } from 'src/app/core/_enums/proofTypes.code';
import { Operation } from 'src/app/core/_models/operation';
import { OperationProof } from 'src/app/core/_models/operationProof';

@Component({
  selector: 'app-dialog-edit-proof',
  templateUrl: './dialog-edit-proof.component.html',
  styleUrls: ['./dialog-edit-proof.component.scss']
})
export class DialogEditProofComponent {
  form: FormGroup;
  justificationOptions: string[] = Object.values(ProofTypeLabelKeys);

  constructor(
    public dialogRef: MatDialogRef<DialogEditProofComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { proof: OperationProof; operation: Operation },
    private fb: FormBuilder
  ) {
    const proovedTypesAsDisplayNames = data.proof.proovedTypes?.map((type) => ProofTypeLabelKeys[type]) || [];

    this.form = this.fb.group({
      comment: [data.proof.comment],
      justificationTypes: [proovedTypesAsDisplayNames, Validators.required]
    });
  }

  onSave(): void {
    if (this.form.valid) {
      const justificationTypes = this.form.value.justificationTypes as string[];
      const proovedTypes = justificationTypes.map((displayName) => LabelKeyToProofType[displayName]).filter((type) => type !== undefined);

      const updatedProof: OperationProof = {
        ...this.data.proof,
        comment: this.form.value.comment,
        proovedTypes: proovedTypes
      };
      this.dialogRef.close(updatedProof);
    }
  }

  onCancel(): void {
    this.dialogRef.close();
  }
}
